import axios from 'axios';
import Semester from '@/models/semester';
import { applyErrorHandlers } from '@/decorators/applyErrorHandler';

const API_SEMESTER_URL = process.env.VUE_APP_API_URL+"/semesters";

export default class SemesterController {
  static async fetchSemesters(includeArchived = false) {
      const response = await axios.get(`${API_SEMESTER_URL}/get_semesters`, {
        params: includeArchived ? { include_archived: true } : {},
      });
      return response.data.map(sem => new Semester(sem));
  }

  static async fetchSemesterById(semesterId) {
      const response = await axios.get(`${API_SEMESTER_URL}/get_semester_by_id/${semesterId}`);
      return new Semester(response.data);
  }

  static async createSemester(semesterData) {
      Semester.validate(semesterData);
      const response = await axios.post(`${API_SEMESTER_URL}/create_semester`, semesterData);
      // When a resource copy was requested, the backend returns a job id header to poll (#77).
      const copyJobId = (response.headers && response.headers['x-semester-copy-job-id']) || null;
      return { semester: new Semester(response.data), copyJobId };
  }

  static async getCopyStatus(jobId) {
      const response = await axios.get(`${API_SEMESTER_URL}/copy_status/${jobId}`);
      return response.data; // { status, done, total, error }
  }

  static async updateSemester(semesterId, semesterData) {
      Semester.validate(semesterData);
      const response = await axios.put(`${API_SEMESTER_URL}/update_semester/${semesterId}`, semesterData);
      return new Semester(response.data);
  }

  static async deleteSemester(semesterId) {
      const response = await axios.delete(`${API_SEMESTER_URL}/delete_semester/${semesterId}`);
      return response.data;
  }

  static async archiveSemester(semesterId) {
      const response = await axios.post(`${API_SEMESTER_URL}/archive_semester/${semesterId}`);
      return response.data;
  }

  static async unarchiveSemester(semesterId) {
      const response = await axios.post(`${API_SEMESTER_URL}/unarchive_semester/${semesterId}`);
      return new Semester(response.data);
  }

  static async prepareNewSemester(semesterData) {
      Semester.validate(semesterData);
      const response = await axios.post(`${API_SEMESTER_URL}/prepare_new_semester`, semesterData);
      return new Semester(response.data);
  }
}

applyErrorHandlers(SemesterController);
